import { Swiper, Autoplay } from "swiper";

class Hero {
    static $captions = document.querySelectorAll("[data-caption-box]");
    static $captionSlides = document.querySelectorAll("[data-caption-slide]");

    constructor() {
        this.$heroSwiperContainer = document.querySelector("[data-hero-swiper]");
        if (!this.$heroSwiperContainer) {
            return;
        }
        this.setup();
    }

    setupSwiper() {
        new Swiper(this.$heroSwiperContainer, {
            speed: 800,
            spaceBetween: 100,
            direction: "vertical",
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
            },
            loop: true,
            allowTouchMove: false,
        });
    }

    showCaption(mutationList) {
        mutationList.forEach((mutation) => {
            if (mutation.target.classList.contains("swiper-slide-active")) {
                Hero.$captions.forEach(($caption) => {
                    const $cap = $caption.querySelector(".c-hero__caption");
                    if (
                        $caption.dataset.captionBox === mutation.target.dataset.captionSlide
                    ) {
                        if ($cap?.classList.contains("c-hero__caption--current")) {
                            return;
                        }
                        $cap?.classList.add("c-hero__caption--current");
                    } else {
                        $cap?.classList.remove("c-hero__caption--current");
                    }
                    $cap?.classList.remove("c-hero__caption--next");
                });
            }

            if (mutation.target.classList.contains("swiper-slide-next")) {
                Hero.$captions.forEach(($caption) => {
                    const $cap = $caption.querySelector(".c-hero__caption");
                    if (
                        $caption.dataset.captionBox === mutation.target.dataset.captionSlide
                    ) {
                        $cap?.classList.add("c-hero__caption--next");
                    }
                });
            }
        });
    }

    /*
     * show correct caption
     */
    setupCaptions() {
        const observer = new MutationObserver(this.showCaption);

        Hero.$captionSlides.forEach(($captionSlide) => {
            observer.observe($captionSlide, {
                attributes: true,
                attributeFilter: ["class"],
            });
        });
    }

    setup() {
        this.setupSwiper();
        this.setupCaptions();
    }
}

export default new Hero();
